import { request } from './request';

const MethodExecutorService = {
	/**
	 * Проверка существования метода в указанном неймспейсе
	 * @param {string} namespace Неймспейс метода
	 * @param {string} methodName Имя метода (case-sensitive)
	 * @returns {Promise<object>} DTO результата проверки
	 */
	exists: async (method, fields = {}) => {
		if (!method) {
			throw new Error('method обязателен');
		}

		const body = {
			method,
			fields
		};
		// Используем POST, так как GET с body не всегда поддерживается браузерами
		const response = await request.post('/api/methodexecutor/exists', body);
		if (!response.ok) {
			throw new Error(`Ошибка проверки существования метода: ${response.status} - ${response.response}`);
		}
		return response.response; // ожидается объект MethodExecuteExistsResultDto
	},

	/**
	 * Выполнение метода через MethodExecutorController
	 * @param {string} method Имя метода (string)
	 * @param {object} fields Объект параметров типа MethodExecutorFields
	 * @returns {Promise<object>} DTO результата выполнения
	 */
	execute: async (method, fields = {}) => {
		if (!method) {
			throw new Error('method обязателен');
		}

		const body = {
			method,
			fields
		};
		const response = await request.post('/api/methodexecutor/execute', body);
		if (!response.ok) {
			throw new Error(`Ошибка выполнения метода: ${response.status} - ${response.response}`);
		}
		return response.response; // ожидается объект MethodExecuteResultDto
	},

	/**
	 * Проверка существования и выполнение метода в одной операции
	 * @param {string} method Имя метода
	 * @param {object} fields Объект параметров типа MethodExecutorFields
	 * @returns {Promise<object>} DTO результата выполнения
	 */
	executeIfExists: async (namespace, method, fields = {}) => {
		const existsResult = await MethodExecutorService.exists(namespace, method);
		if (!existsResult.Success) {
			throw new Error(`Метод ${method} не найден в неймспейсе ${namespace}`);
		}
		return await MethodExecutorService.execute(method, fields);
	}
};

export default MethodExecutorService;
